import { useResourceList } from '@koopajs/react';
import { ICommittee } from 'types';

export const useCommitteeName = (committeeId: string): string | undefined => {
  const { resources: committees } = useResourceList<ICommittee>({ path: '/committees', useCache: true }); //everywhere but 1 place
  const committee = committees.find((c) => c.id === committeeId);
  return committee?.name;
};
